import SuratJalanDelivery from '@/models/SuratJalanDelivery/SuratJalanDelivery';

export default class SuratJalanDeliveryFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.suratJalanNumber = '';
		this.id = '';
		this.deliveryInstructionId  = '';
		this.deliveryInstructionDiNumber = '';
		this.deliveryDateFrom = '';
		this.deliveryDateTo = '';
		this.isAlreadyDeliver = false;
		this.customerId  = '';
		this.customerCode = '';
		this.destinationId  = '';
		this.destinationCode = '';
		this.remarksMultiple = '';
		this.driverName = '';
		this.vehicleNumber = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			suratJalanNumber : '0',
			id : '0',
			deliveryInstructionId : '0',
			deliveryInstructionDiNumber : '0',
			deliveryDateFrom : '0',
			deliveryDateTo : '0',
			isAlreadyDeliver : '0',
			customerId : '0',
			customerCode : '0',
			destinationId : '0',
			destinationCode : '0',
			remarksMultiple : '0',
			driverName : '0',
			vehicleNumber : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}